import axios from 'axios';
import store from "@/store/store"
import router from '@/router/router';
import loginApi from '@/apis/loginApi';
import { getCheckWebView, getLang } from '@/utils/commonUtils';
import bridgeApi from '@/apis/bridgeApi';
import i18n from '@/config/i18nConfig'


const notTokenUrl = [
  `${process.env.VUE_APP_API_URL_API}/api/v1/oauth/login`,
  `${process.env.VUE_APP_API_URL_API}/api/v1/oauth/refresh-token`,
  `${process.env.VUE_APP_API_URL_API}/api/v1/common-code/getList`,
  `${process.env.VUE_APP_API_URL_API}/api/v1/service/serviceSaveNotAuth`,
  `${process.env.VUE_APP_API_URL_API}/api/v1/service/getDataNotAuth`,
  `${process.env.VUE_APP_API_URL_API}/api/v1/device/req/requestMqtt`,
  
]


// 요청 인터셉터 추가하기  -> 서버에 요청하기전 인터셉터
axios.interceptors.request.use(
async (config) => {
    // store 데이터 저장
    // await store.dispatch('loading/setLoadingData', true);

    // console.log("=================request ==============================")
    // console.log("요청 url", config.url)
    //스토어에서 현재 access token와 refresh token을 가져온다
    const accessToken = store.getters['login/getAccessToken'];
    //console.log(accessToken)

    //토큰을 headers에 추가한다.

    // 헤더에 access 토큰이 필요없는 url 요청이 있다.
    // 그런데 유효하지않는(기간만료된) 토큰을 오히려 header에 추가해주면 서버에서 토큰 유효하지않다고 뱉어내니 그냥 제거해서보내기
    if (notTokenUrl.includes(config.url)) {
      delete config.headers.Authorization
    }else{
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    config.headers['Content-Type'] = 'application/json;charset=utf-8';

    return config;
},
 async (error) => {
    await store.dispatch('loading/setLoadingData', false);
    return Promise.reject("request error :" ,error);
}
);

/**
 * 기본 url 세팅 - 가장 상단의 url
 */
const getDefaultUrl = (info) => {
  let defaultUrl = ''

  if(info?.menuList){
    defaultUrl = info?.menuList.find((item) => item.siteUrl !== "").siteUrl
  }
  
  return defaultUrl
}

/**
 * 리프레시 토큰 으로 access 토큰 재발급 하기
 */
const refresh = async (originalConfig) => {
  // 리프레시 토큰정보를 가져온다
  const accessToken = store.getters['login/getAccessToken'];
  const refreshToken = store.getters['login/getRefreshToken'];

  // 토큰이 있을경우
  if (accessToken && refreshToken ) {

      console.log("리프레시토큰 api 토큰재발큽 요청")
      const result = await loginApi.refreshToken({ token : accessToken , refreshToken : refreshToken})
      console.log("result :" , result);

      
      //성공적으로 재발급받았으면 토큰 갱신한다.
      if(result){
        const defaultUrl = getDefaultUrl(result.data)
        const loginData = {
          accessToken: result.data.tokenInfo.accessToken,
          refreshToken: result.data.tokenInfo.refreshToken,
          userInfo: result.data.userInfo,
          menuList: result.data.menuList,
          defaultUrl : defaultUrl,
          userName :result.data.userName,
          email : result.data.email,
          userAuth : result.data.userAuth,
          awsAccessInfo: result.data.awsAccessInfo,
          id : result.data.userInfo.id,
          loginId : result.data.userInfo.loginId,
          phone: result.data.userInfo.phone,
      };
      // 스토어에저장한 토큰, 사용자, 메뉴정보 갱신
      await store.dispatch('login/setLoginData', loginData);

      // 원래 보내려고한 api 재호출하기
      console.log("성공적으로 토큰 재발급받았으니 원래 하려고했던 api 재호출", originalConfig.url);

      let checkWebView = getCheckWebView();  
    
      if("browser" !== checkWebView){
          let data = JSON.stringify(loginData)
          let param = {
              type : "sendLoginInfo",
              data : data
          }
          // 웹뷰 브릿지 호출하기
          bridgeApi.sendLoginInfo(param)
      }

      // window.reload
      // return axios(originalConfig);
      window.location.reload();

    }
  } else {
      await refreshFire();
  }
};

/**
 * 인증 실패했을때 스토어값 초기화, 및 로그인페이지로이동시키기
 */
const refreshFire = async () => {
  await store.dispatch('login/setLogoutData');
  await router.push('/login');
};
// 응답 인터셉터 추가하기  -> 서버에 요청하고난후 response 인터셉터
axios.interceptors.response.use( async function (response) {

    return response;

  }
  , async function (error) {
    // console.log("===error === 여기타니??")
    console.log("error : ", error)
    await store.dispatch('loading/setLoadingData', false);
    if(error.response){
      // 에러 상태가 401 에러면 represh 로 토큰 재요청 하기
      if(error.response.status === 401){
        console.log("===== error.response.status === 401 ==========")
        // 리프레시 요청이 아니면
        if(error.config.url !== `${process.env.VUE_APP_API_URL_API}/api/v1/oauth/refresh-token`){
          // 토큰 재요청
          const originalConfig = error.config
          await refresh(originalConfig);
        }else{
          //리프레시 토큰인데 403에러면 토큰만료 됬으므로 로그인페이지로이동
          await refreshFire();
        }
      }else if(error.response.status === 400){
        //리프레시 토큰으로 토큰 재발급시 오류나면 다시 로그인처리
        if(error.config.url === `${process.env.VUE_APP_API_URL_API}/api/v1/oauth/refresh-token`){
          await refreshFire();
        }else{
          
          // //운영환경에서 서버에러시 "시스템오류 관리자에게 문의하세요 로표기"
          // if (process.env.NODE_ENV == 'production'){   
          // //process.env.NODE_ENV   이거는 로컬 또는 개발일때 development로 표기됨 만약 로컬과 개발을 분리하고싶다면 별도의 env변수를만들어야하는듯  
          //   store.dispatch("alert/open", { title : "" ,message : i18n.global.t(`response.message.${error.response.data.code}`) })
          // }else{
          //   store.dispatch("alert/open", { title : "" ,message : error.response.data.data || error.response.data.message })
          // }
          store.dispatch("alert/open", { title : "" ,message : i18n.global.t(`response.message.${error.response.data.code}`) })

        }
      }else if(error.response.status === 504){
        store.dispatch("alert/open", { title : "" ,message : i18n.global.t('message.MSG_00004')}) // MSG_00004 : 데이터를 가져오지 못했어요. 다시 시도해주세요. 반복적인 현상 발생시 관리자에게 문의주시기 바랍니다.
      }
    }else{
      if("ERR_NETWORK" === error.code){
        store.dispatch("alert/open", { title:"" , message : i18n.global.t('message.MSG_00005')}) // MSG_00005 : 네트워크 연결 끊김
      }

      //await refreshFire();
    }


    return Promise.reject(error);
  }
);

export default axios
